import React, { Component } from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'

import MaskedInput from 'react-text-mask'
import { Fonts, Colors } from '../theme'

class InputField extends Component {
  constructor (props) {
    super(props)
    this.resetValue = this.resetValue.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.returnMask = this.returnMask.bind(this)
    this.state = {
      value: props.value
    }
  }

  resetValue () {
    if (this.input) { this.input.inputElement.value = '' }
  }

  handleChange (e, v) {
    e.preventDefault()
    let { limit = null, value = '' } = this.props
    if (!limit || (value.length <= limit && e.target.value.length <= limit)) {
      if (this.props.mask) {
        this.props.onChange(e, e.target.value.toUpperCase())
      } else {
        this.props.onChange(e, this.input.value)
      }
    } else return null
  }

  returnMask (props) {
    const { inputRef, ...other } = props

    return (
      <MaskedInput
        {...other}
        ref={inputRef}
        mask={this.props.mask}
      // placeholderChar={'\u2000'}
      // showMask
      />
    )
  }

  render () {
    const props = this.props
    return (

      <FormControl className={props.readOnly && 'disabled'} error={!!props.errorText} fullWidth={props.fullWidth} style={{ margin: '10x 0', cursor: props.readOnly && 'not-allowed' }}>
        <InputLabel
          htmlFor={props.id}
          style={{
            // fontSize: props.floatingLabelFixed ? 'calc(0.85rem * 0.75)' : '0.85rem',
            // lineHeight: '0.77rem',
            // fontSize: '0.77rem',
            cursor: props.readOnly && 'not-allowed',
            color: props.readOnly ? Colors.Palette.disabledTextColor : Colors.Palette.primaryTextColor,
            fontFamily: Fonts.primaryFontFamily
          }}
          shrink={props.floatingLabelFixed}
        >
          {props.floatingLabelText}
        </InputLabel>
        {this.props.mask
          ? <Input
            id={props.id}
            onChange={this.handleChange}
            endAdornment={<InputAdornment>{this.props.adornment || ''}</InputAdornment>}
            value={props.value || ''}
            inputRef={(i) => { this.maskedInput = i }}
            type={props.type}
            inputComponent={this.returnMask}
            onBlur={props.onBlur}
            onKeyPress={props.onKeyPress}
            readOnly={props.readOnly}
          />
          : <Input
            id={props.id}
            onChange={this.handleChange}
            endAdornment={<InputAdornment>{this.props.adornment || ''}</InputAdornment>}
            value={props.value}
            inputRef={(input) => { this.input = input }}
            type={props.type}
            onBlur={props.onBlur}
            onKeyPress={props.onKeyPress}
            readOnly={props.readOnly}
          />}
        {!props.readOnly && <FormHelperText id="component-error-text" style={{ marginBottom: 10, fontSize: 12 }}>{props.errorText}</FormHelperText>}
      </FormControl>
    )
  }
}

export default InputField



// WEBPACK FOOTER //
// ./src/controls/InputField.js